import React, { useEffect, useState } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { SitePal } from "sitepal-react-v2";

import "./App.css";

function App() {

  return (
    <>
      <div className="home">
        <header className="main_header">
          <div className="left_div">
            <div className="logo logo_heading">
              <a href="/"><img src="//sitepal.com/api/examples/images/logo.png" alt="SitePal" /></a>
            </div>
          </div>
          <div className="right_div">
          </div>
        </header>
        <table id="tblContainer" cellSpacing="0" align="center" border="0">
          <tbody>
            <tr>
              <td id="tdContent">
                <p className="feature_entire_heading text-center f-bold h2" align="center">
                  <b>React JS - AI Bot with Speech Recognition</b>
                </p>
                <p className="feature_entire_heading text-center" id="normal-text" align="center">
                  This is React JS example of a working AI Bot that uses Web Speech API to listen to user input (instead of typed input).
                </p>
                <p className="feature_entire_heading text-center" id="warning-text">
                  Note: as we've detected this browser does not yet support the Web Speech API we've automatically replaced speech input with text input.
                </p>
                <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <td align="center" colSpan="2" className="feature_entire_heading text-center sayAi">
                      <SitePal
                          embed='3432155,600,800,"",1,1, 2695693, 0,1,1,"c3ecd7055a9d58e95ce593a5cf2a8fba",0'
                        />
                        <br />
                        <form name="myForm" className="form" onSubmit={e => e.preventDefault()}>
                          <input name="textToSay" id="myInput" defaultValue="" className="form-control d-inline w-25" style={{ display: 'none' }} />
                          <input type="button" id="myButton" defaultValue="Ask AI Engine" onClick={() => { window.preSayAI(); }} className="btn btn-primary" style={{ display: 'none' }} />
                          <div className="p-3" id="p-3" style={{ border: '1px solid gray', height: '300px', borderRadius: '8px' }}>
                            <span id="final" className="text-light"></span>
                            <span id="interim" className="text-secondary"></span>
                          </div>
                          <div className="mt-4" id="mt-4">
                            <a id="start">Start Listening</a>
                            <a id="stop">Stop Listening</a>
                            <p id="status" className="lead mt-3 text-light" style={{ display: 'none' }}>Listening ...</p>
                          </div>
                          <br /><br />
                        </form>
                        <iframe id="simple-content" align="top" height="200" width="400"></iframe>
                      </td>
                    </tr>
                    <tr align="middle">
                      <td align="center" colSpan="2" className="feature_entire_heading text-center">
                        <button className="btn btn_child shadow" type="button" id="btn1" value="SOURCE CODE" style={{backgroundColor:'#ff6600',margin:"20px auto 0px"}} ><a className="download" href="/api/examples/react-ai/react-ai.zip" style={{color:"#fff"}} download>Download Source Code</a></button>
                        <p>Real-time Artificial Intelligence Engine provides automatic Text and Audio responses to the questions provided.</p>
                        <p>The Audio is generated automatically via a Text To Speech engine according to the selected voice and language.</p>
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p></p>
              </td>
            </tr>
          </tbody>
        </table>
        <footer>
          <div className="footer-menu oddcast text-center">
            <ul className="w-50 m-auto">
              <li className="w-100 f-bold">Please feel free to use the source code of this page as an example.</li>
              <li>To view the source code of this page, follow <a className="selected_support" target="_new" href="https://www.computerhope.com/issues/ch000746.htm">these instructions</a></li>
            </ul>
          </div>
        </footer>
        <div className="text-center">
          <p className="feature_entire_heading copy_right">© 2003 - {new Date().getFullYear()} Oddcast Inc. All Right Reserved</p>
        </div>
      </div>
    </>
  );
}

export default App;
